import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type DeleteShipmentStatusParams } from '../infra/ShipmentRepository'

export type DeleteShipmentStatusFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function deleteShipmentStatusFactory({
  shipmentRepository,
}: DeleteShipmentStatusFactoryDependencies) {
  return async function remove(
    params: DeleteShipmentStatusParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await shipmentRepository.deleteShipmentStatus(params, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not delete shipment status', { cause: error as Error })
    }
  }
}

export function deleteShipmentStatus(
  params: DeleteShipmentStatusParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const remove = deleteShipmentStatusFactory({ shipmentRepository })

  return remove(params, config)
}
